<form
  (ngSubmit)="onSubmit()"
  [formGroup]="formGroup">
  <love-it-modal-header
    (close)="closeModal()"
    [title]="editText"></love-it-modal-header>
  <ul
    #nav="ngbNav"
    class="nav nav-tabs card-header-tabs"
    ngbNav>
    <li
      [destroyOnHide]="false"
      ngbNavItem="stammdaten">
      <a
        [invalid]="submitted && formGroup.invalid"
        label="Stammdaten"
        love-it-tab
        ngbNavLink></a>
      <ng-template ngbNavContent>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6">
                <label
                  class="required-label"
                  for="name"
                  >Name</label
                >
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('name')?.errors,
                  }"
                  class="form-control"
                  formControlName="name"
                  id="name"
                  type="text" />
                @if (submitted && formGroup.get("name")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("name")?.errors["required"]) {
                      <div>Name ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-6">
                <label
                  class="required-label"
                  for="address"
                  >Adresse</label
                >
                <input
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('address')?.errors,
                  }"
                  class="form-control"
                  formControlName="address"
                  id="address"
                  type="text" />
                @if (submitted && formGroup.get("address")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("address")?.errors["required"]) {
                      <div>Adresse ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
              <div class="col-sm-12">
                <label
                  class="required-label"
                  for="officeId"
                  >Standort</label
                >
                <ng-select
                  [formControl]="formGroup.get('officeId') | formControl"
                  [items]="offices"
                  bindLabel="name"
                  bindValue="id"
                  [clearable]="false"
                  [searchable]="false"
                  id="officeId"
                  [ngClass]="{
                    'is-invalid': submitted && formGroup.get('officeId')?.errors,
                  }"></ng-select>
                @if (submitted && formGroup.get("officeId")?.errors) {
                  <div class="invalid-feedback">
                    @if (formGroup.get("officeId")?.errors["required"]) {
                      <div>Standort ist ein Pflichtfeld.</div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>
  <div class="modal-body">
    <div
      [ngbNavOutlet]="nav"
      class="mt-2"></div>
  </div>
  <div class="modal-footer">
    <love-it-modal-buttons
      (onSubmit)="onSubmit($event)"
      [dirty]="formGroup.dirty"
      [showSpeichernButton]="CaslAction.Update | permission: EntityTyp.Housing"></love-it-modal-buttons>
  </div>
</form>
